import Index from './views/Index.js';
import Billing from './views/Billing.js';
import Help from './views/Help.js';
import Webhook from './views/Webhook.js';
import ProductsTable from './views/ProductsTable';
import OrderHistory from './views/OrderHistory';
import Credentials from './views/Credentials';

var routes = [
  {
    path: '/home',
    name: 'Home',
    icon: 'ni ni-tv-2 text-primary',
    component: Index,
    layout: '',
  },
  {
    path: '/products',
    name: 'Products',
    icon: 'ni ni-bullet-list-67 text-green',
    component: ProductsTable,
    layout: '',
  },
  {
    path: '/notifications',
    name: 'Notification Setup',
    icon: 'ni ni-notification-70 text-red',
    component: Webhook,
    layout: '',
  },
  {
    path: '/credentials',
    name: 'Credentials',
    icon: 'ni ni-single-02 text-yellow',
    component: Credentials,
    layout: '',
  },
  {
    path: '/billing',
    name: 'Billing',
    icon: 'ni ni-credit-card text-primary',
    component: Billing,
    layout: '',
  },
  {
    path: '/help',
    name: 'Need Help?',
    icon: 'ni ni-support-16 text-info',
    component: Help,
    layout: '',
  },
];
export default routes;
